<template>
    <div class="grid grid-cols-2 gap-4 p-4 sm:p-0">
        <div class="flex">
            <h3 class="font-medium text-sm sm:text-2xl text-gray-600 transition duration-500 ease-in-out dark:text-white">{{ moment(race.starts_at).format('kk:mm') }} {{ meeting.name }} {{ race.results.length ? '(Race Complete)' : '' }}</h3>
        </div>
        <div class="flex justify-end">
            <h3 class="font-medium text-sm sm:text-2xl text-gray-600 transition duration-500 ease-in-out dark:text-white">{{ race.runners.length }} Runners</h3>
        </div>
        <div class="flex col-span-2 mb-4">
            <p class="text-sm sm:text-lg text-center sm:text-left font-light transition duration-500 ease-in-out dark:text-white">{{ race.title }}</p>
        </div>
    </div>
</template>
<script>
import moment from 'moment'

export default {
    props: {
        meeting: Object,
        race: Object,
    },

    setup(props) {

        return {
            moment
        }

    }
}

</script>
